export class PenPipeSizeDto {
  public static ApiUrl = 'api/pen-pipe-size';

  Id: number;
  Name: string;
  Size: number;
}

export class CheckDuplicatePenPipeSize {
  Id?: number;
  Size: number;
}
